<template>
  <!--リストボックス管理 -->
  <div id="ListEdit">
    <div id="container">
      <masterNavi v-bind:pageid='"ListEdit"'></masterNavi>
      <div class="labelTitle label">リストボックス編集</div>
      <section>
        <div class="labelTitle label">
            HST機種<a style="float:right;" @click="hstKind.open = !hstKind.open"><b-icon v-if="hstKind.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="hstKind.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'hstKind', hstKind)" :disabled="hstKind.edit">行追加</b-button>          
            <b-table
                :data="data.hstKind.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'hstKind', props.index, hstKind)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'hstKind', props.index, hstKind)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'hstKind', props.index, hstKind)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            PSG解析方法<a style="float:right;" @click="psgMethod.open = !psgMethod.open"><b-icon v-if="psgMethod.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="psgMethod.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'psgMethod', psgMethod)" :disabled="psgMethod.edit">行追加</b-button>          
            <b-table
                :data="data.psgMethod.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="返却日数" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.label4" min="2" /></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'psgMethod', props.index, psgMethod)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'psgMethod', props.index, psgMethod)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'psgMethod', props.index, psgMethod)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            PSG解析レポート形式<a style="float:right;" @click="psgReportFormat.open = !psgReportFormat.open"><b-icon v-if="psgReportFormat.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="psgReportFormat.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'psgReportFormat', psgReportFormat)" :disabled="psgReportFormat.edit">行追加</b-button>          
            <b-table
                :data="data.psgReportFormat.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'psgReportFormat', props.index, psgReportFormat)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'psgReportFormat', props.index, psgReportFormat)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'psgReportFormat', props.index, psgReportFormat)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            SleepwareG3のバージョン<a style="float:right;" @click="sleepwareG3Ver.open = !sleepwareG3Ver.open"><b-icon v-if="sleepwareG3Ver.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="sleepwareG3Ver.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'sleepwareG3Ver', sleepwareG3Ver)" :disabled="sleepwareG3Ver.edit">行追加</b-button>          
            <b-table
                :data="data.sleepwareG3Ver.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'sleepwareG3Ver', props.index, sleepwareG3Ver)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'sleepwareG3Ver', props.index, sleepwareG3Ver)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'sleepwareG3Ver', props.index, sleepwareG3Ver)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            企業検診の検査種類<a style="float:right;" @click="kenshinKind.open = !kenshinKind.open"><b-icon v-if="kenshinKind.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="kenshinKind.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'kenshinKind', kenshinKind)" :disabled="kenshinKind.edit">行追加</b-button>          
            <b-table
                :data="data.kenshinKind.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="256"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'kenshinKind', props.index, kenshinKind)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'kenshinKind', props.index, kenshinKind)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'kenshinKind', props.index, kenshinKind)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            企業検診の機種<a style="float:right;" @click="kenshinDevice.open = !kenshinDevice.open"><b-icon v-if="kenshinDevice.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="kenshinDevice.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'kenshinDevice', kenshinDevice)" :disabled="kenshinDevice.edit">行追加</b-button>          
            <b-table
                :data="data.kenshinDevice.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="edit" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'kenshinDevice', props.index, kenshinDevice)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'kenshinDevice', props.index, kenshinDevice)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'kenshinDevice', props.index, kenshinDevice)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            ホルター心電図の機種<a style="float:right;" @click="holterKind.open = !holterKind.open"><b-icon v-if="holterKind.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="holterKind.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'holterKind', holterKind)" :disabled="holterKind.edit">行追加</b-button>          
            <b-table
                :data="data.holterKind.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'holterKind', props.index, holterKind)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'holterKind', props.index, holterKind)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'holterKind', props.index, holterKind)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            ホルター心電図解析方法<a style="float:right;" @click="holterMethod.open = !holterMethod.open"><b-icon v-if="holterMethod.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="holterMethod.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'holterMethod', holterMethod)" :disabled="holterMethod.edit">行追加</b-button>
            <b-table
                :data="data.holterMethod.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'holterMethod', props.index, holterMethod)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'holterMethod', props.index, holterMethod)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'holterMethod', props.index, holterMethod)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
      <section>
        <div class="labelTitle label">
            ホルターHST併用申込の機種<a style="float:right;" @click="holterHstKind.open = !holterHstKind.open"><b-icon v-if="holterHstKind.open" icon="minus-box" type="is-white"/><b-icon v-else icon="chevron-down-box" type="is-white"/></a>
        </div>
        <div v-if="holterHstKind.open" class="containtsArea">
            <b-button class="is-primary addRowButton" icon-left="table-row-plus-after" @click="addRow(data,'holterHstKind', holterHstKind)" :disabled="holterHstKind.edit">行追加</b-button>
            <b-table
                :data="data.holterHstKind.choicesList"
                id="listEditTable">
                <template slot-scope="props">
                    <b-table-column field="id" label="ID" width="60" centered>
                        {{props.row.id}}
                    </b-table-column>
                    <b-table-column field="value" label="value" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.value" maxlength="20"/></template>
                        <template v-else>{{props.row.value}}</template>
                    </b-table-column>
                    <b-table-column field="label1" label="ラベル1" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label1" maxlength="100"/></template>
                        <template v-else>{{props.row.label1}}</template>
                    </b-table-column>
                    <b-table-column field="label2" label="ラベル2" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label2" maxlength="100"/></template>
                        <template v-else>{{props.row.label2}}</template>
                    </b-table-column>
                    <b-table-column field="label3" label="分類" width="300">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label3" maxlength="100"/></template>
                        <template v-else>{{props.row.label3}}</template>
                    </b-table-column>
                    <b-table-column field="label4" label="分類2" width="100">
                        <template v-if="props.row.mode == 'edit'"><input type="text" v-model="props.row.label4" maxlength="100"/></template>
                        <template v-else>{{props.row.label4}}</template>
                    </b-table-column>
                    <b-table-column field="displayOrder" label="表示順" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="number" v-model="props.row.displayOrder" :min="1" :max="999"/></template>
                        <template v-else>{{props.row.displayOrder}}</template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="論理削除" width="80" centered>
                        <template v-if="props.row.mode == 'edit'"><input type="checkbox" v-model="props.row.deleteFlag"/></template>
                        <template v-else><input type="checkbox" v-model="props.row.deleteFlag" disabled/></template>
                    </b-table-column>
                    <b-table-column field="deleteFlag" label="編集" width="200" centered>
                        <template v-if="props.row.mode == 'edit'">
                            <b-button class="rowButton herfSize is-primary" @click="save(data,'holterHstKind', props.index, holterHstKind)">保存</b-button>
                            <b-button class="rowButton herfSize is-primary" @click="cancelEdit(data,'holterHstKind', props.index, holterHstKind)">キャンセル</b-button>
                        </template>
                        <template v-else-if="props.row.mode == 'show'">
                            <b-button class="rowButton is-primary" @click="edit(data,'holterHstKind', props.index, holterHstKind)">編集</b-button>
                        </template>
                    </b-table-column>
                </template>
            </b-table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "ListEdit",
  methods: {
    edit: function(data, tableName, index, cntrol) {
        this.originalRowData[tableName] = JSON.parse(JSON.stringify(data[tableName].choicesList[index]));
        console.log(this.originalRowData[tableName])
        cntrol.edit = true;
        for(var rowData of data[tableName].choicesList){
            rowData.mode = "none";
        }
        data[tableName].choicesList[index].mode = "edit"
    },
    save: async function(data, tableName, index, cntrol) {
        var item = data[tableName].choicesList[index];
        var duplicateDatas = data[tableName].choicesList.filter(val => val.id != item.id && val.value == item.value)
        if(duplicateDatas && duplicateDatas.length > 0){
            this.showErrorMessage("value値が重複しています。値を変更してください。");
            return;
        }

        if(!item.displayOrder || item.displayOrder == ''){
            this.showErrorMessage("表示順を数値で入力してください。");
            return;
        }
        if(parseInt(item.displayOrder, 10) < 1 || parseInt(item.displayOrder, 10) > 999){
            this.showErrorMessage("表示順を1以上999以下で入力してください。");
            return;
        }

        if(tableName == 'psgMethod'){
            let returnDays = parseInt(item.label4, 10)
            if(isNaN(returnDays)){
                this.showErrorMessage("返却日数を数値で入力してください。");
                return;
            }
            if(returnDays < 2){
                this.showErrorMessage("返却日数を2以上で入力してください。");
                return;
            }
            item.label4 = String(returnDays);
        }
        if(item.label4 == null){
            item.label4 = '';
        }
        // WebAPI Call
        let _this = this;
        await this.apiCall(
            function (client){
                return client.apis.internalMaintenance.setMaintenanceListBoxContentsPOST({
                     body: {
                        id: item.id + "",
                        choicesType: data[tableName].choicesType,
                        value: item.value,
                        label1: item.label1,
                        label2: item.label2,
                        label3: item.label3,
                        label4: item.label4,
                        displayOrder: parseInt(item.displayOrder, 10),
                        deleteFlag: item.deleteFlag,
                     }
                 });
            },
            function(result) {
                data[tableName].choicesList[index].id = result.obj.id;
                _this.originalRowData[tableName] = null;
                cntrol.edit = false;
                for(var rowData of data[tableName].choicesList){
                    rowData.mode = "show";
                }
            },
            _this.setMaintenanceListBoxContentsPOSTError
        );
    },
    setMaintenanceListBoxContentsPOSTError: function(result) {
      this.showErrorMessage(result);
    },    
    addRow: function(data, tableName, cntrol) {
        this.originalRowData[tableName] = "addRow";
        cntrol.edit = true;
        for(var rowData of data[tableName].choicesList){
            rowData.mode = "none";
        }
        data[tableName].choicesList.push(
            {mode:"edit",id:"-" ,value:"",label1:"",label2:"",label3:"",label4:"",displayOrder:"",deleteFlag:false},
        );
    },
    cancelEdit: function(data, tableName, index, cntrol) {
        console.log(this.originalRowData[tableName])
        if(this.originalRowData[tableName] == "addRow"){
            data[tableName].choicesList.splice(data[tableName].choicesList.length-1, 1);
        } else {
            data[tableName].choicesList[index] = this.originalRowData[tableName];
        }
        cntrol.edit = false;
        for(var rowData of data[tableName].choicesList){
            rowData.mode = "show";
        }
    },
    getChoicesList: async function() {
      // WebAPI Call
      let _this = this;
      await this.apiCall(
          function (client){
            return client.apis.apiCommon.getChoicesListPOST({ body: {} });
          },
          _this.getChoicesListPOSTSuccess,
          _this.getChoicesListPOSTError);
    },
    getChoicesListPOSTSuccess: function(result) {
      for(let item of result.obj){
          for(let choice of item.choicesList){
              choice["mode"] = "show";
          }
          if(item.choicesType==this.choicesType.hstKind){
              this.data.hstKind.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.psgMethod){
              this.data.psgMethod.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.psgReportFormat){
              this.data.psgReportFormat.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.sleepwareG3Ver){
              this.data.sleepwareG3Ver.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.kenshinKind){
              this.data.kenshinKind.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.kenshinDevice){
              this.data.kenshinDevice.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.holterKind){
              this.data.holterKind.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.holterMethod){
              this.data.holterMethod.choicesList = item.choicesList;
          } else if(item.choicesType==this.choicesType.holterHstKind){
              this.data.holterHstKind.choicesList = item.choicesList;
          }
      }
    },
    getChoicesListPOSTError: function(result) {
      this.showErrorMessage(result);
    },
  },
  data() {
    return {
      choicesType:choicesType,
      data:{
          hstKind:{choicesType:choicesType.hstKind ,choicesList:[]},
          psgMethod:{choicesType:choicesType.psgMethod ,choicesList:[]},
          psgReportFormat:{choicesType:choicesType.psgReportFormat ,choicesList:[]},
          sleepwareG3Ver:{choicesType:choicesType.sleepwareG3Ver ,choicesList:[]},
          kenshinKind:{choicesType:choicesType.kenshinKind ,choicesList:[]},
          kenshinDevice:{choicesType:choicesType.kenshinDevice ,choicesList:[]},
          holterKind:{choicesType:choicesType.holterKind ,choicesList:[]},
          holterMethod:{choicesType:choicesType.holterMethod ,choicesList:[]},
          holterHstKind:{choicesType:choicesType.holterHstKind ,choicesList:[]},
      },
      hstKind:{open:true, edit:false},
      psgMethod:{open:true, edit:false},
      psgReportFormat:{open:true, edit:false},
      sleepwareG3Ver:{open:true, edit:false},
      kenshinKind:{open:true, edit:false},
      kenshinDevice:{open:true, edit:false},
      holterKind:{open:true, edit:false},
      holterMethod:{open:true, edit:false},
      holterHstKind:{open:true, edit:false},
      originalRowData:{}
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
  },
  mounted: async function(){
      await this.getChoicesList();
  }
  
};
</script>
<style lang="scss" scoped>
.labelTitle {
  width:1300px;
}
.containtsArea {
  margin-top:10px;
  width:1300px;
}
.rowButton {
    height: 30px;
}
.rowButton.herfSize {
    width: 48%;
}
.addRowButton {
    float: right;
    margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/list/ListEdit.vue